const OfferAdvantagesModel = {};

OfferAdvantagesModel.SAFE = {
  id: 'safe',
  text: 'Safe Service',
  img: '/images/icons/offer_advantages/safety.svg',
  tooltip: `We strictly monitor the compliance with security measures.
          Our PROs never use bots or scripts; they never use in-game chats.
          Also, we prevent the intersection of IP and MAC addresses.`,
};

OfferAdvantagesModel.HANDMADE_SAFE = {
  id: 'safe',
  text: 'Handmade 100% Safe',
  img: '/images/icons/offer_advantages/safety.svg',
  tooltip: `We strictly monitor the compliance with security measures.
          Our PROs never use bots or scripts; they never use in-game chats.
          Also, we prevent the intersection of IP and MAC addresses.`,
};

OfferAdvantagesModel.SSL = {
  id: 'ssl',
  text: 'SSL Secure',
  img: '/images/icons/offer_advantages/ssl.svg',
  tooltip: 'Your data is fully protected and encrypted using SSL and HTTPS protocols',
};

OfferAdvantagesModel.VPN = {
  id: 'vpn',
  text: 'VPN, Safe Boost',
  img: '/images/icons/offer_advantages/vpn.svg',
  tooltip: `We use the VPN of your country to disguise our actions on the account.<br><br>
          This greatly increases the security of the account.`,
};

OfferAdvantagesModel.SUPPORT = {
  id: 'support',
  text: '24/7 Support',
  img: '/images/icons/offer_advantages/support.svg',
  tooltip: 'Your gaming needs are covered 24 hours a day, 7 days a week',
};

OfferAdvantagesModel.REFUNDS = {
  id: 'refunds',
  text: 'Money refunds',
  img: '/images/icons/offer_advantages/money_return.svg',
  tooltip: `We provide a full or partial refund if you change your mind or if there is an accident.<br><br>
          You can learn more about this from the operator.`,
};

OfferAdvantagesModel.CASHBACK = {
  id: 'cashback',
  text: 'Cashback',
  img: '/images/icons/offer_advantages/cashback.svg',
  tooltip: `We automatically give you {cashback} equivalent of your orders price on your personal account.
    Сashback is not credited for orders with a promo code and for orders of in-game currency, you can find out more 
    <a href="/cashback" target="_blank">here</a>`,
};

OfferAdvantagesModel.GUARANTY = {
  id: 'guaranty',
  text: '1 hour average delivery time',
  img: '/images/icons/offer_advantages/guaranty.svg',
  tooltip: `We guarantee delivery in 24 hours, if delivery did not take place within 24 hours due to our fault,
          we will compensate for the delay.<br><br>
          If you order a large amount or play on server with a small population, the delivery time may be increased`,
};

OfferAdvantagesModel.LIST_BASE = [
  OfferAdvantagesModel.SSL,
  OfferAdvantagesModel.VPN,
  OfferAdvantagesModel.SAFE,
  OfferAdvantagesModel.SUPPORT,
  OfferAdvantagesModel.REFUNDS,
  OfferAdvantagesModel.CASHBACK,
];

// Старая голда
OfferAdvantagesModel.LIST_GOLD = [
  OfferAdvantagesModel.GUARANTY,
  OfferAdvantagesModel.SSL,
  OfferAdvantagesModel.VPN,
  OfferAdvantagesModel.SAFE,
  OfferAdvantagesModel.SUPPORT,
];

// Новый маркетплейс валюты
OfferAdvantagesModel.LIST_CURRENCY = [
  OfferAdvantagesModel.SSL,
  OfferAdvantagesModel.VPN,
  OfferAdvantagesModel.SAFE,
  OfferAdvantagesModel.SUPPORT,
];

OfferAdvantagesModel.LIST_ACCOUNTS = [
  OfferAdvantagesModel.GUARANTY,
  OfferAdvantagesModel.SSL,
  OfferAdvantagesModel.HANDMADE_SAFE,
  OfferAdvantagesModel.SUPPORT,
];

export default OfferAdvantagesModel;
